var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1452_2431)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84794 11.8728C9.76214 10.7831 11.1792 9.51422 13.1598 8.87721L13.5068 9.95612C11.7952 10.5066 10.5455 11.6127 9.71616 12.6012C9.30292 13.0937 8.99931 13.5509 8.8 13.883C8.70049 14.0489 8.6274 14.1828 8.58002 14.2736C8.55633 14.3189 8.5391 14.3534 8.52824 14.3756L8.51671 14.3995L8.51468 14.4038C8.51469 14.4038 8.51527 14.404 8.51468 14.4038H7.48604C7.48544 14.404 7.48603 14.4038 7.48604 14.4038L7.48328 14.3995L7.47175 14.3756C7.46089 14.3534 7.44366 14.3189 7.41998 14.2736C7.37259 14.1828 7.2995 14.0489 7.19999 13.883C7.00068 13.5509 6.69707 13.0937 6.28384 12.6012C5.45445 11.6127 4.2048 10.5066 2.49316 9.95612L2.84016 8.87721C4.82083 9.51422 6.23785 10.7831 7.15205 11.8728C7.25148 11.9913 7.34521 12.1079 7.43333 12.2218V1.5L8.56666 1.5V12.2218C8.65478 12.1079 8.74851 11.9913 8.84794 11.8728Z",
    fill: "#0033AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1452_2431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 13,
    fill: "white",
    transform: "translate(2 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.479aa2a071eb555de8b55945aa373409.svg";
export { ForwardRef as ReactComponent };